/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class DynamoDbBackupConfig {
  /**
  * The cloud account ID for the configuration, if account or resource level
  */
  'accountId'?: string;
  /**
  * The resource ID for the configuration, if resource level
  */
  'resourceId'?: string;
  /**
  * The maximum RCUs for the table
  */
  'maxReadCapacityUnits'?: number;
  /**
  * The maximum read capacity percentage for the table
  */
  'maxReadCapacityPercentage'?: number;
  /**
  * Whether to enable Eon autoscale service for the table
  */
  'isAutoscaleEnabled': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accountId",
      "baseName": "accountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "maxReadCapacityUnits",
      "baseName": "maxReadCapacityUnits",
      "type": "number",
      "format": ""
    },
    {
      "name": "maxReadCapacityPercentage",
      "baseName": "maxReadCapacityPercentage",
      "type": "number",
      "format": ""
    },
    {
      "name": "isAutoscaleEnabled",
      "baseName": "isAutoscaleEnabled",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DynamoDbBackupConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

